module.exports = __webpack_public_path__ + "img/repair-man.23f135b.webp";